import React from 'react';
import { Link } from 'gatsby';
import useInfoSectionData from './dataQuery';
import Button from '../../Button';
import { BgImage, InfoBox, InfoSectionContent } from './styles';
import { SITE_TITLE } from '../../../constants';

const InfoSectionComponent: React.FC = () => {
  const { frontmatter } = useInfoSectionData();

  return (
    <InfoSectionContent>
      <section className="section info-section info-allya" id="info-section">
        <BgImage left="5vw" top="30%" image="img/bg_1.svg" width={146} height={118} />
        <BgImage right="8vw" image="img/bg_2.svg" width={70} height={70} />
        <BgImage right="8vw" top="60%" image="img/bg_3.svg" width={114} height={80} />

        <div className="container">
          <div className="column is-9 column-info">
            <div className="content">
              <h2>
                Você sabe o que é a <b>Allya?</b>
              </h2>
              <div className="description-box">
                <p>
                  Com a Allya, que é uma rede de benefícios e parcerias, você, associado {SITE_TITLE}, terá descontos em
                  28 mil estabelecimentos em todo o Brasil!
                </p>
                <p>
                  A plataforma conta com parceiros de diversas categorias, oferecendo serviços on-line para você
                  economizar sem sair de casa e também descontos em milhares de estabelecimentos físicos.
                </p>
                <p>
                  Para ter esses descontos "para chamar de seu", é necessário ativar a conta no botão abaixo. É
                  rapidinho!
                </p>
                <Link to="/register">
                  <Button title={frontmatter.buttonText} classType="fat" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section info-section section--gradient">
        <div className="container">
          <div className="column is-12 register-section">
            <h2>
              Veja as vantagens de <b>ativar sua conta</b>
            </h2>
            <div className="content box-list">
              {frontmatter.itens &&
                frontmatter.itens.map((el: any) => (
                  <InfoBox key={el.icon}>
                    <img src={`img/${el.icon}`} alt={el.icon} />
                    <div>
                      <p>{el.title}</p>
                      <span>{el.description}</span>
                    </div>
                  </InfoBox>
                ))}
            </div>
          </div>
        </div>
      </section>
    </InfoSectionContent>
  );
};

export default InfoSectionComponent;
